<template>
   <v-container>
    <v-row>
      <v-col cols="4">
        <v-text-field id="taxDistrictEditDialogSchoolDistrictText"
          class="tax-district-edit-dialog-school-district-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.districtCode"
          label="Tax District"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field id="taxDistrictEditDialogDistrictNameText"
          class="tax-district-edit-dialog-district-name-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.districtName"
          label="Name"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4" v-if="!this.globalSettingItem.useNewTaxUnitSetup">
        <v-select id="taxDistrictEditDialogToUnitSelect"
          class="tax-district-edit-dialog-to-unit-select"
          label="Tax Unit"
          v-model="editedItem.taxUnit"
          :items="toUnitDescList"
          item-text="toUnitDesc"
          item-value="_id"
          @blur="somethingChanged"
        >
        </v-select>
      </v-col>

      <v-col cols="4" v-if="this.globalSettingItem.useNewTaxUnitSetup">
        <v-select id="taxDistrictEditDialogToUnitSelect"
          class="tax-district-edit-dialog-to-unit-select"
          label="Tax Unit"
          v-model="editedItem.toUnitDescForAppro"
          :items="toUnitDescList"
          item-text="toUnitDesc"
          item-value="toUnitDescForAppro"
          @blur="somethingChanged"
        >
        </v-select>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="2">
        <v-checkbox id="taxDistrictEditDialogRemitFundsCheckbox"
          class="tax-district-edit-dialog-remit-funds-checkbox"
          v-model="editedItem.isRemitFund"
          label="Remit Funds"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox id="taxDistrictEditDialogJointCountyCheckbox"
          class="tax-district-edit-dialog-joint-county-checkbox"
          v-model="editedItem.isJointCounty"
          label="Joint County"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox id="taxDistrictEditDialogSpecialAssessmentCheckbox"
          class="tax-district-edit-dialog-special-assessment-checkbox"
          v-model="editedItem.isSpecialAssessment"
          label="Special Assessment"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox id="taxDistrictEditDialogAdaForCalculationFlagCheckbox"
          class="tax-district-edit-dialog-ada-for-calculation-flag-checkbox"
          v-model="editedItem.isRequiredAdaForCalculation"
          label="Required ADA for calculation"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-text-field
          :value="editedItem.ada"
          label="ADA"
          readonly
          ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-checkbox id="taxDistrictEditDialogTifBaseCheckbox"
          class="tax-district-edit-dialog-tif-base-checkbox"
          v-model="editedItem.isTifBase"
          label="TIF Base"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox id="taxDistrictEditDialogTifDistributionCheckbox"
          class="tax-district-edit-dialog-tif-distribution-checkbox"
          v-model="editedItem.isTifDistribution"
          label="TIF Distribution"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox id="taxDistrictEditDialogPenaltyFollowsUnitCheckbox"
          class="tax-district-edit-dialog-tif-distribution-checkbox"
          v-model="editedItem.isPenaltyFollowsUnit"
          label="Penalty Follows Unit"
          @blur="somethingChanged"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-text-field
        v-model="editedItem.glAltKey"
        v-uppercase=globalSettingItem.conEverythingToCaps
          label="GL Alt Key"
          ></v-text-field>
      </v-col>
        <v-col cols="3">
        <v-text-field
        v-model="editedItem.apportionmentGlAltKey"
        v-uppercase=globalSettingItem.conEverythingToCaps
          label="Apportionment GL Alt Key"
          ></v-text-field>
      </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxDistrictEditedItem',
  mixins: [GlobalToCaps],
  components: {
  },
  data: () => ({
    taxUnitCrudKey: 'sharedTaxUnit',
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxDistrict-dialog',
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    toUnitDescList() {
      const unitDescObj = this.items(this.taxUnitCrudKey) || [];
      const updatedUnitDescObj = unitDescObj.map((u) => ({
        ...u,
        toUnitDesc: `${u.toUnitDescForAppro || ''}  ${u.description || ''}`,
      }));
      return [{ _id: null, toUnitDescForAppro: '', toUnitDesc: '' }, ...updatedUnitDescObj];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    somethingChanged() { // Is this required?
      this.$emit('input', this.editedItem);
    },
  },
};
</script>
